import * as React from "react"

import { cn } from "@/lib/utils"

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[120px] w-full rounded-sm border border-[hsl(var(--border-hairline))] bg-[hsl(var(--panel))] px-3 py-2.5 text-[13px] text-[hsl(var(--fg-cream))] transition-colors duration-200",
          "placeholder:text-[hsl(var(--fg-muted))]",
          "focus-visible:outline-none focus-visible:border-[hsl(var(--accent-brick))] focus-visible:ring-1 focus-visible:ring-[hsl(var(--accent-brick))]",
          "disabled:cursor-not-allowed disabled:opacity-50 resize-none",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
